var HandleValidtionResultAction = (function (CheckoutSettings) {

	var HandleValidtionResultAction = function () { };
	HandleValidtionResultAction.prototype.handle = function (reason, options) {
		if (reason === CheckoutSettings.Validation.ShippingAvailability) {
			alert(kos.getPageTemplate('_ImpossibleToDeliverAtLocation_Message'));
		}
        else if (reason === CheckoutSettings.Validation.Delivery) {
            alert(kos.getPageTemplate('js_selectAddress'));
            (new AddDeliveryAddressDisplayCommand(options)).invoke();
		} else if (reason === CheckoutSettings.Validation.GiftBillingAddress) {
			alert('Please enter Gift Recipient\'s delivery address and your Billing address');
            (new AddDeliveryAddressDisplayCommand(options)).invokeGiftAndBilling();
		} else if (reason === CheckoutSettings.Validation.GiftAddress) {
			alert('Please enter Gift Recipient\'s delivery address');
            (new AddDeliveryAddressDisplayCommand(options)).invokeGift();
		}else if (reason === CheckoutSettings.Validation.BillingAddress) {
			alert('Please enter your Billing address');
            (new AddDeliveryAddressDisplayCommand(options)).invokeBilling();
		} else if (reason === CheckoutSettings.Validation.TermsAndConditions) {
			alert(kos.getPageTemplate('_CheckoutTermsAndConditionsValidationFailed'));
		} else if (reason === CheckoutSettings.Validation.TermsAndConditionsOurPay) {
		    alert(kos.getPageTemplate('_OurPayTCValidationFailed'));
        } else if (reason === CheckoutSettings.Validation.TermsAndConditionsOurPaySelect) {
            alert(kos.getPageTemplate('_OurPaySelectTCValidationFailed'));
        } else if (reason === CheckoutSettings.Validation.AgeRestricted) {
            alert(kos.getPageTemplate('_PleaseConfirmAgeRestrictedText'));
        }
	};

	return HandleValidtionResultAction;
})(CheckoutSettings);

var CheckoutButtonsView = (function (BaseView) {

	var CheckoutButtonsView = BaseView.extend({

		el: '#bt-checkout-buttons',

		initialize: function () {
			this.$all = this.$el.find('#bt-checkout-buttons-all');
			this.$current = this.$el.find('#bt-checkout-buttons-current');
            this.listenTo(this.model, 'change', _.bind(this._render, this));
			this._render();
		},

        _render: function () {
            var hasMethod = !this.model.isEmpty();
            var isApplicablePaymentMethod = this.model.isApplicable();

            var displayAll = !hasMethod || !isApplicablePaymentMethod;

            //hasMethod = !this.model.isEmpty() && !this.model.isOurpaySelect();
            this.$all.toggle(true);
            this.$current.toggle(!displayAll);
		}
	});

	return CheckoutButtonsView;
})(BaseView);

var PaymentMethodView = (function (_, BaseView) {

	// NOTE: For friendly names, better to move it to some "constants" or settings
	// NOTE: but meh due to ASAP DEVELOPING
	var mapPaymentMethodName = function(name) {
		var mapping = {};
		mapping[CheckoutSettings.PaymentType.VisaCheckoutBT] = {
			fName: 'Click to Pay',
			cName: 'VisaCheckout'
		};
		mapping[CheckoutSettings.PaymentType.VisaCheckoutCS] = {
			fName: 'Click to Pay',
			cName: 'VisaCheckout'
		};
		return mapping[name] ||
		{
            fName: name,
			cName: name
		};
	};

	var PaymentMethodView = BaseView.extend({

        className: 'bt-payment-method',

		events: {
			'click': 'select'
		},

		initialize: function (opts) {
			opts = opts || {};

			this.listenTo(this.model, 'change', _.bind(this.render, this, opts));
			this.listenTo(this.model, 'remove', _.bind(this.remove, this));

			this.render(opts);
		},

		select: function () {
			this.model.select();
            this.trigger('selected');
            //this.display('checkout');
        },

		render: function (opts) {
			var modelJ = this.model.toJSON();
			var mappedPaymentMethodName = mapPaymentMethodName(modelJ.PaymentType);
			_.extend(modelJ,
				{
					friendlyName: mappedPaymentMethodName.fName,
					className: mappedPaymentMethodName.cName
				});
			this.$el.html($.tmpl(opts.templateName || 'bt-checkout-payment-method', modelJ));
			this.$el.toggleClass('bt-payment-method-selected', !!this.model.get('Selected'));
		}
	});

	return PaymentMethodView;
})(_, BaseView);

var PaymentMethodsListView = (function (_, BaseView, PaymentMethodView) {

	var PaymentMethodsListView = BaseView.extend({

		el: '#bt-checkout-payment-method-list',

		initialize: function () {
			var el = this.$el.addClass('bt-payments-list-loading');

			this.listenTo(this.collection, 'add', _.bind(this._renderItem, this));

			this.render();

			this.collection.done(function () {
				el.removeClass('bt-payments-list-loading');
			});

			this.collection.error(function (data) {
				if (!data || !data.IsAuthenticated) {
					return;
				}
				alert(data.Message);//tbd: common handler, alert wrapper
			});
		},

		render: function () {
			this.collection.each(_.bind(this._renderItem, this));
		},

		_renderItem: function (model) {
			var item = new PaymentMethodView({ model: model });
			this.$el.append(item.$el);
			item.on('selected', _.bind(function() {
                this.trigger('selected');
            }, this));
        },

		toggle: function(show) {
            this.$el.toggleClass('hidden-block', !show);
        },

		showAll: function(show) {
			this.$el.toggleClass('show-only-selected', !show);
        }
	});

	return PaymentMethodsListView;
})(_, BaseView, PaymentMethodView);

var PaymentMethodsView = (function (BaseView, PaymentMethodsListView) {

    var PaymentMethodsView = BaseView.extend({
		el: '#bt-checkout-payment-methods',

		displayRoutes: ['checkout'],

        events: {
            'click #bt-checkout-payment-method-add': '_add',
            'click #bt-checkout-payment-method-change': '_change'
        },

		mode: {
			new: 1,
			current: 2,
			list: 3
        },

        initialize: function(opts) {

            this._changeModeHandler = opts.changeModeHandler;

            this.listView = new PaymentMethodsListView({ collection: this.model });
			
			this.currentPaymentMethod = this.$('@current-payment-methods');
			this.currentPaymentButton = this.$('#bt-checkout-buttons-current');
            this.addButton = this.$('#bt-checkout-payment-method-add');
            this.changeButton = this.$('#bt-checkout-payment-method-change');
            this.creditCardForm = this.$('#bt-checkout-form');
			this.currentPaymentMethods = this.$('@current-payment-methods');

			this.model.done(_.bind(this.render, this));

            this.listView.on('selected', _.bind(function () {
                this._setMode(this.mode.current);
            }, this));
        },

        render: function() {
            var selected = this.model.getSelected();

            this.addButton.html($.tmpl('bt-checkout-payment-method-add'));
            this.changeButton.html($.tmpl('bt-checkout-payment-method-change'));

            if (selected) {
				this._setMode(this.mode.current);
            } else {
				this._setMode(this.mode.new);
			}
        },

		_setMode: function(mode) {
			this.currentMode = mode;
			mode === this.mode.new && this.__showNew();
			mode === this.mode.current && this.__showCurrent();
			mode === this.mode.list && this.__showList();
            this._changeModeHandler.trigger('changeMode', mode);
        },

		__showCurrent: function() {
            this.listView.showAll(false);
			this.listView.toggle(true);
			this.currentPaymentMethod.removeClass('hidden-block');
            this.currentPaymentButton.css('display', 'block');
            this.creditCardForm.addClass('hidden-block');
            this.addButton.toggleClass('hidden-block', this.model.length !== 1);
            this.changeButton.toggleClass('hidden-block', this.model.length < 2);
		},

		__showNew: function() {
			this.creditCardForm.removeClass('hidden-block');
			this.listView.toggle(false);
			this.currentPaymentMethod.addClass('hidden-block');

			if (this.model.length === 0) {
                this.addButton.addClass('hidden-block');
                this.changeButton.addClass('hidden-block');
			} else {
				this.addButton.addClass('hidden-block');
                this.changeButton.removeClass('hidden-block');
            }
        },

		__showList: function() {
			this.listView.showAll(true);
			this.listView.toggle(true);
			this.currentPaymentMethod.removeClass('hidden-block');
            this.currentPaymentButton.css('display', 'none');
            this.creditCardForm.addClass('hidden-block');
            this.addButton.removeClass('hidden-block');
            this.changeButton.addClass('hidden-block');
        },

		_add: function () {
            this._setMode(this.mode.new);
        },
		_change: function () {
			if (this.model.length > 1) {
                this._setMode(this.mode.list);
			} else {
				this._setMode(this.mode.current);
            }
        }
    });

	return PaymentMethodsView;
})(BaseView, PaymentMethodsListView);

var PaymentButtonBaseView = (function ($, _, BaseView, PromiseUtil, HandleValidtionResultAction) {

    var PaymentButtonBaseView = BaseView.extend({

        _availablePaymentOptions: [],

		events: {
			'click': 'click'
		},

		initialize: function (opts) {
			this.$el = opts.el ? $(opts.el) : $.tmpl(opts.template, _.extend({
				id: opts.container + '-' + opts.provider.type
            }, opts.tmplOpts || {})).appendTo($(opts.container));

			this._preventDefault = _.isUndefined(opts.preventDefault) || opts.preventDefault;

			this._service = opts.service;
            this._service_3ds = opts.service_3ds || null;
			this._provider = opts.provider;

            this._backTo = opts.backTo || 'checkout';

		    _.bindAll(this, "_availablePaymentOptionsChanged");
		    opts.order._onUpdateCheckout(this._availablePaymentOptionsChanged);

            opts.loadingPromise && this._handleLoading(opts.loadingPromise);

            // NOTE: anyway get available payment options, because view can be mounted after checkout update
		    this._availablePaymentOptionsChanged();
		},

		click: function (e) {
			if (e && e.preventDefault && this._preventDefault) {
				e.preventDefault();
			}

			var value = this._service.checkValid();

			if (value.result) {
				var el = this.$el.addClass('bt-checkout-btn-progress');
				this._pay()
                    .pipe(_.bind(this._complete, this), _.bind(this._error, this))
                    .always(function () {
                    	el.removeClass('bt-checkout--btn-progress');
                    });
			} else {
				(new HandleValidtionResultAction()).handle(value.reason, { backTo: this._backTo });
			}
		},

		setService: function (service) {
			this._service = service;
		},

		setProvider: function (provider) {
			this._provider = provider;
		},

		_complete: function (data) {
			// stub
		},

		_pay: function () {
			return PromiseUtil.rejected();
		},

		_handleLoading: function (loadingPromise) {
			var el = this.$el.addClass('bt-checkout-btn-initialize');
			loadingPromise.done(function () {
				el.removeClass('bt-checkout-btn-initialize');
			});
        },

		_availablePaymentOptionsChanged: function (data) {
			var _paymentOptions = this.options &&
				this.options.order &&
                this.options.order.attributes &&
                this.options.order.attributes.AvailablePaymentOptions ||
				null;

            if (data && data.Value && data.Value.AvailablePaymentOptions) {
                this._availablePaymentOptions = data.Value.AvailablePaymentOptions;
			} else if ($.isArray(_paymentOptions)) {
				this._availablePaymentOptions = _paymentOptions;
            }
        },

		isPaymentProviderApplicable: function (providerPaymentOption, options) {
            options = options || this._availablePaymentOptions;
            return !!providerPaymentOption &&
                (_.some(options,
                    function(po) {
                        return po.Name.toLowerCase() === providerPaymentOption.toLowerCase();
                    }.bind(this)));
        },

        // TBD: Should be decomposed.
        _error: function (error) {
            if (error && error.Value && error.Value.threeDsRequired && this._service_3ds && !this._tryPayWith3DS) {                
                this._tryPayWith3DS = true;
                this.setService(this._service_3ds);
                this.click();
            } else if (error && error.Value && !error.Value.isPaid && error.Value.response === 'basket_changed') {
                alert(kos.getPageTemplate('_OrderTotalsChanged'));
                this._provider.update_checkout();
            } else {
                this._tryPayWith3DS = false;
                if (error && error.type === CheckoutSettings.paymentServiceErrorTypes.threeDS) {
                    error.payload && alert(error.payload.message);
                } else if (error && error.Message && this._provider.hideErrors) {
                    alert(error.Message);
                } else if (typeof (error) === 'string') {
                    alert(error);
                }
            }
        }
	});

	return PaymentButtonBaseView;
})($, _, BaseView, PromiseUtil, HandleValidtionResultAction);

var MyPayTransactionsView = (function (GetPageTemplate) {

	var MyPayTransactionsView = Backbone.View.extend({

		hiddenClass: 'hidden-block',

		className: 'schedule-container schedule-container__checkout',

		initialize: function (opts) {
			this._convertMoney = opts.convertMoney || window.toMoney;
			this._currencySign = opts.currencySign || GlobalSettings.CurrencySign;
			this.render();
			this.$el.attr('role', 'myPayBillingPlan');
			this.$el.addClass(opts.type || 'medium');
			this._hide();
			this.$el.addClass(opts.testClassName || 'test-mypay-transactions');
		},

		render: function () {
			var transactions = this.collection;
			var total = 0;

			for (var i = 0; i < transactions.length; i++) {
				var transaction = transactions[i];
				var row = $('<div/>').addClass('schedule-row');
				row.append(this._createDate(transaction));
				row.append(this._createProgressLine(transaction, transactions.length));
				row.append(this._createStatus(transaction));
				this.$el.append(row);
				total += transaction.Amount;
			}

			total && this._renderTotal(total);
		},

		_show: function () {
			return this.$el.removeClass('hiddenClass');
		},

		_hide: function () {
			return this.$el.addClass('hiddenClass');
		},

		_renderTotal: function (total) {
			var row = $('<div/>').addClass('schedule-row');
			var totalText = this._convertMoney(total, this._currencySign);
			var leftCell = $('<div/>').addClass('schedule-total').text(GetPageTemplate('_Total')),
				centerCell = $('<div/>').addClass('schedule-wrapper'),
				rightCell = $('<div/>').addClass('schedule-status').text(totalText);
			row.append(leftCell, centerCell, rightCell);
			this.$el.append(row);
		},

		_createProgressLine: function (transaction, transactionsCount) {
			var wrapper = $('<div />').addClass('schedule-wrapper');
			var cell = $('<div />').addClass('schedule-cell');
			var line = $('<div />')
				.addClass('schedule-line')
				.addClass('schedule-line__color_' + transactionsCount + '_' + transaction.Number);
			cell.append(line);
			wrapper.append(cell);

			for (var i = 1; i <= transactionsCount; i++) {
				cell.append(this._createCircle(transactionsCount, i, transaction.Number));
			}

			return wrapper;
		},

		_createCircle: function (transactionsCount, sequenceNumber, transactionNumber) {
			var circle = $('<div />')
				.addClass('schedule-circle')
				.addClass('schedule-circle_' + transactionsCount + '_' + sequenceNumber)
				.text(sequenceNumber);

			if (transactionNumber >= sequenceNumber) {
				circle.addClass('schedule-circle__color');
			}

			return circle;
		},

		_createDate: function (transaction) {
			var text = transaction.Number === 1 ?
				GetPageTemplate('_Today') :
				transaction.PlannedDate.getDateFromMS().format('dd mmm');
			return $('<div/>')
				.addClass('schedule-date')
				.text(text);
		},

		_createStatus: function (transaction) {
			var status = $('<div/>').addClass('schedule-status');
			var type = 'pedning';
			var text = kos.toMoney(transaction.Amount, this._currencySign);

			if (transaction.State === 2) {
				type = 'paid';
				text = '<span class="sprite-icon paid-icon"></span>' + GetPageTemplate('_Paid');
			}

			return status.addClass(type).html(text);
		}
	});

	return MyPayTransactionsView;

})(kos.getPageTemplate);

var PaymentButtonView = (function (PaymentButtonBaseView) {

    var PaymentButtonView = PaymentButtonBaseView.extend({

        initialize: function (opts) {
			PaymentButtonBaseView.prototype.initialize.apply(this, arguments);

            this.currentMode = 1;

            if (opts.current) {
                this.listenTo(opts.current, 'change', _.bind(this._toggle, this));
                this._current = opts.current;
                this._toggle();
			}

			if (opts.changeModeHandler) {
				opts.changeModeHandler.on('changeMode', _.bind(this._changeMode, this));
            }

            this.buttonType = opts.buttonType;

            if (opts.order) {
                _.bindAll(this, "_toggle");
                opts.order._onUpdateCheckout(this._toggle);
            }
        },

		_pay: function () {

			return this._service
                       .pay(this._provider);
		},

        _toggle: function () {
            var show = this.isPaymentProviderApplicable(this._provider.paymentOption);
            var isDirect = this._current.isDirect();
		    this.$el.toggle(show && !isDirect && this.currentMode === 1);
		},

		 _changeMode: function(e, mode) {
			 this.currentMode = mode || 1;
             this._toggle();
         }
	});

	return PaymentButtonView;
})(PaymentButtonBaseView);

var PayWithMethodButtonView = (function (_, PaymentButtonBaseView) {

	var PayWithMethodButtonView = PaymentButtonBaseView.extend({

		initialize: function (opts) {
			PaymentButtonBaseView.prototype.initialize.apply(this, arguments);
			// NOTE: back to checkout, not to payments form
			this._backTo = 'checkout';
			this.listenTo(opts.current, 'change', _.bind(this._toggle, this));
            this._current = opts.current;

		    if (opts.order) {
		        _.bindAll(this, "_toggle");
		        opts.order._onUpdateCheckout(this._toggle);
            }

            this._toggle();
            this._logger = opts.logger;
		},

		_pay: function () {
		    var method = this._current.toJSON();

		    if (CheckoutSettings.PaymentType.MasterPass !== method.PaymentType 
		        || CheckoutSettings.PaymentType.VisaCheckoutBT !== method.PaymentType 
		        || CheckoutSettings.PaymentType.VisaCheckoutCS !== method.PaymentType 
		        || CheckoutSettings.PaymentType.None !== method.PaymentType) {
		        this._logger && this._logger();
		    }

			return this._service
                       .useMethod(this._provider, method);
		},

		_toggle: function () {
			var method = this._current.toJSON();
		    var isDirect = this._current.isDirect();
		    var show = this._provider.isApplicable(method) &&
                !method.DisplayOurPayAlone &&
                ( this._current.isDirect() || this.isPaymentProviderApplicable(this._provider.paymentOption) );
			this.$el.toggle(show && (!isDirect || this._provider.type === CheckoutSettings.PaymentType.Direct.toLocaleLowerCase()));
		}
	});

	return PayWithMethodButtonView;
})(_, PaymentButtonBaseView);

var OurPayButtonView = (function (PayWithMethodButtonView) {

	var OurPayButtonView = PayWithMethodButtonView.extend({
		initialize: function(opts) {
			PayWithMethodButtonView.prototype.initialize.apply(this, arguments);
			this.listenTo(opts.current, 'change', _.bind(this._toggle, this));
			this._current = opts.current;
			this.$el.addClass(opts && opts.testClass || 'test-mypay-button');
		},

		_toggle: function () {
			/* var method = this._current.toJSON();
			var isDirect = this._current.isDirect();

			var providerIsApplicable = this._provider.isApplicable(method);
			var isApplicable = this.isPaymentProviderApplicable(this._provider.paymentOption);
			
			var show = providerIsApplicable && isApplicable && !isDirect; */
            this.$el.toggle(true);
        }
	});

	return OurPayButtonView;

})(PayWithMethodButtonView);

var PaymentOurPayButtonView = (function (_, OurpayButtonFormBase, PaymentButtonView) {

    var _OurPayButtonView = PaymentButtonView.extend({
		click: function () {
			var order = this.options.order;
			var current = this._current;

			window.app && app.event && app.event.ourpay();

			if (order.get('OurPayMode') === 3) {
				var value = this._service.checkValid();

				if (value.result) {
					var el = kos.dialog.popup({
						title: '',
						message: $.tmpl('ourpay-klarna-popup').html(),
						hideOnClick: false,
						hideOnOverlayClick: true,
						closeBtn: true
					});
					el.$('@klarna-ourpay-button-other').on('click', el.destroy);

					var settings = CheckoutSettings.getBasketSettings();

					el.$('@klarna-ourpay-button').on('click', function (evt) {
						evt.preventDefault();

						if (settings.KlarnaEnabled) {
							var validator = new PaymentValidator(order, null, null);

							var prePayment = function () {
								var _validate = validator.validate();
								if (_validate.result) {
									return new $.Deferred().resolve().promise();
								}
								setTimeout(function () {
									(new HandleValidtionResultAction()).handle(_validate.reason, { backTo: 'checkout' });
								}, 100);
								return new $.Deferred().reject().promise();
							}

							var afterPayment = function (data) {
								if (data.Result && data.Value.isPaid) {
									confirmation.set({
										invoiceNo: data.Value.invoiceNo || data.Value.InvoiceNo,
										paymentID: data.Value.PaymentID,
										orderInfoResult: data.Value.OrderInfoResult,
										plannedTransactions: data.Value.PlannedTransactions,
										paymentType: data.Value.PaymentType,
										voucher: data.Value.voucher,
										un: data.Value.un,
										addressString: data.Value.AddressString || '',
										addressAdditionalData: data.Value.AddressAdditionalData
									});
								}
							}

							var toggle = function () {
								var isDirect = current.isDirect();
								var _show = _.some(order.get('AvailablePaymentOptions'), function (po) {
									var show = po.Name.toLowerCase() === CheckoutSettings.PaymentOption.Klarna.toLowerCase();
									return show && !isDirect;
								});
								$('#klarna').toggleClass('hidden-block', !_show);
								$('#klarna-tc-text').toggleClass('hidden-block', !_show);
							}

							var klarna = KlarnaHelper(prePayment, afterPayment);
							klarna.buttonPopup();

							order.on('sync', function () {
								order._onUpdateCheckout(toggle);
								toggle();
							});
						}

						el.destroy();
					});
				} else {
					(new HandleValidtionResultAction()).handle(value.reason, { backTo: this._backTo });
                }
			} else {
				PaymentButtonView.prototype.click.apply(this, arguments);
			}
        },
        _toggle: function () {
        }
    });

    var PaymentOurPayButtonView = OurpayButtonFormBase.extend({

        container: '#bt-checkout-form-buttons',

		_renderButton: function (testClass) {
			var settings = CheckoutSettings.getBasketSettings();

			if (settings.StripeEnabled && settings.StripeEnabledWithOurPay) {
				this.ourPayStripeButtonView = new _OurPayButtonView({
					el: this._$myPayStripeButton,
					service: this._services.stripe,
					provider: this._providers.stripe,
					testClass: testClass,
					order: this.options.order
				});
				this._$myPayButton.remove();
			} else {
				this.ourPayButtonView = new _OurPayButtonView({
					el: this._$myPayButton,
					service: this._services.ourpay,
					service_3ds: this.service_3ds,
					provider: this._providers.braintree,
					testClass: testClass,
					order: this.options.order
				});
				this._$myPayStripeButton.remove();
			}
        },

		_toggle: function () {
			var ourPayMode = this.options.order.get('OurPayMode');
			var isOurPayEnabled = ourPayMode === 1 || ourPayMode === 3;

			if (this.model.isEnabled() && this.currentMode === 1 && isOurPayEnabled) {
                this._show();
            } else {
                this._hide();
            }
            return this;
        }
    });

    return PaymentOurPayButtonView;
})(_, OurpayButtonFormBase, PaymentButtonView);

var PayWithOurPayView = (function (_, OurpayButtonFormBase, OurPayButtonView) {

    var _OurPayButtonView = OurPayButtonView.extend({
		click: function () {
			var order = this.options.order;
			var current = this._current;

			window.app && app.event && app.event.currentOurpay(current.get('PaymentType'));

			if (order.get('OurPayMode') === 3) {
				var value = this._service.checkValid();

				if (value.result) {
					var el = kos.dialog.popup({
						title: '',
						message: $.tmpl('ourpay-klarna-popup').html(),
						hideOnClick: false,
						hideOnOverlayClick: true,
						closeBtn: true
					});
					el.$('@klarna-ourpay-button-other').on('click', el.destroy);

					var settings = CheckoutSettings.getBasketSettings();

					el.$('@klarna-ourpay-button').on('click', function (evt) {
						evt.preventDefault();

						if (settings.KlarnaEnabled) {
							var validator = new PaymentValidator(order, null, null);

							var prePayment = function () {
								var _validate = validator.validate();
								if (_validate.result) {
									return new $.Deferred().resolve().promise();
								}
								setTimeout(function () {
									(new HandleValidtionResultAction()).handle(_validate.reason, { backTo: 'checkout' });
								}, 100);
								return new $.Deferred().reject().promise();
							}

							var afterPayment = function (data) {
								if (data.Result && data.Value.isPaid) {
									confirmation.set({
										invoiceNo: data.Value.invoiceNo || data.Value.InvoiceNo,
										paymentID: data.Value.PaymentID,
										orderInfoResult: data.Value.OrderInfoResult,
										plannedTransactions: data.Value.PlannedTransactions,
										paymentType: data.Value.PaymentType,
										voucher: data.Value.voucher,
										un: data.Value.un,
										addressString: data.Value.AddressString || '',
										addressAdditionalData: data.Value.AddressAdditionalData
									});
								}
							}

							var toggle = function () {
								var isDirect = current.isDirect();
								var _show = _.some(order.get('AvailablePaymentOptions'), function (po) {
									var show = po.Name.toLowerCase() === CheckoutSettings.PaymentOption.Klarna.toLowerCase();
									return show && !isDirect;
								});
								$('#klarna').toggleClass('hidden-block', !_show);
								$('#klarna-tc-text').toggleClass('hidden-block', !_show);
							}

							var klarna = KlarnaHelper(prePayment, afterPayment);
							klarna.buttonPopup();

							order.on('sync', function () {
								order._onUpdateCheckout(toggle);
								toggle();
							});
						}

						el.destroy();
					});
				} else {
					(new HandleValidtionResultAction()).handle(value.reason, { backTo: this._backTo });
				}
			} else {
				OurPayButtonView.prototype.click.apply(this, arguments);
            }
        }
    });

    var PayWithOurPayView = OurpayButtonFormBase.extend({

        container: '#bt-checkout-buttons-current',

		_renderButton: function (testClass) {
			var settings = CheckoutSettings.getBasketSettings();

			if (settings.StripeEnabled && settings.StripeEnabledWithOurPay) {
				this.ourPayButtonStripeView = new _OurPayButtonView({
					el: this._$myPayStripeButton,
					service: this._services.stripe,
					provider: this._providers.stripe,
					current: this._current,
					testClass: testClass,
					order: this.options.order
				});
				this._$myPayButton.remove();
			} else {
				this.ourPayButtonView = new _OurPayButtonView({
					el: this._$myPayButton,
					service: this._services.ourpay,
					service_3ds: this.service_3ds,
					provider: this._providers.braintree,
					current: this._current,
					// TBD: test classes should be added another way
					testClass: testClass,
					order: this.options.order
				});
				this._$myPayStripeButton.remove();
            }
        },

        _toggle: function () {
            OurpayButtonFormBase.prototype._toggle.apply(this, arguments);
            var isEnabled = this.model.isEnabled();
            var method = this._current.toJSON();
			var braintreeIsApplicable = this._providers.braintree.isApplicable(method);
			var stripeIsApplicable = this._providers.stripe.isApplicable(method);
			var ourPayMode = this.options.order.get('OurPayMode');
			var isOurPayEnabled = ourPayMode === 1 || ourPayMode === 3;
			var isOurPaySelect = this._current._options.isOurpaySelect();

			if (isEnabled && this.currentMode >= 2 && isOurPayEnabled) {
				this._show();
				!(braintreeIsApplicable || stripeIsApplicable) && this._hide();
            } else {
                this._hide();
            }
            return this;
        }
    });

    return PayWithOurPayView;
})(_, OurpayButtonFormBase, OurPayButtonView);

var IPayButtonView = (function ($, PaymentButtonView) {

	var IPayButtonView = PaymentButtonView.extend({

		_complete: function (data) {
			$(data).appendTo('body').submit();
		}
	});

	return IPayButtonView;
})($, PaymentButtonView);

var HummButtonView = (function ($, PaymentButtonView) {

    var HummButtonView = PaymentButtonView.extend({

        _complete: function (data) {
            $(data).appendTo('body').submit();
        }
    });

    return HummButtonView;
})($, PaymentButtonView);
